import { resolveComponent as _resolveComponent, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: "Challenge",
  class: "w-screen min-h-screen-inner gradient-3"
}
const _hoisted_2 = { class: "w-full background-dotted-pattern-alpha-05 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Challenge = _resolveComponent("Challenge")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(_component_Challenge, {
            "challenge-type": "newTestament",
            "question-creator": _ctx.newTestamentQuestionCreator
          }, null, 8, ["question-creator"])
        ]),
        _: 1
      }))
    ])
  ]))
}